import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useParams, useNavigate } from 'react-router-dom';
import WebChatPage from './View/UserSide/WebChatPage';
import ChatWindow from './View/AgentSide/ChatWindow';
import ChatBotMainScreen from './View/ChatBot/ChatBotMainScreen'

// Yönlendirme komponenti
const WebChatRedirect: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // Eğer URL '/WebChat/Main' ile başlıyorsa yönlendirme yap
        if (location.pathname === '/WebChat/Main') {
            // Mevcut query parametrelerini (guid ve hId) al
            const searchParams = new URLSearchParams(location.search);
            const guid = searchParams.get('guid');
            const hId = searchParams.get('hId');

            // Yeni URL'ye yönlendir
            navigate(`/tr-TR/WebChat?guid=${guid}&hId=${hId}`, { replace: true });
        }
    }, [location, navigate]);

    return <div>Yönlendiriliyor...</div>;
};


const App: React.FC = () => {
    return (
        <Router>
            <Routes>
                {/* Eski URL yapısındaki istekleri yakalayan ve yönlendirme yapan route */}
                <Route path="/WebChat/Main" element={<WebChatRedirect />} />

                <Route path="/:lang/AgentChat" element={<ChatWindow />} />{/* Agent tarafı */}
                <Route path="/:lang/WebChat" element={<WebChatPage />} /> {/* Kullanıcı tarafı */}
                <Route path="/:lang/ChatBot" element={<ChatBotMainScreen />} /> {/* Chat Bot tarafı */}
            </Routes>
        </Router>
    );
};

export default App;
